import Footer from "../components/Footer";

export default function PrivacyPage({ onNav }) {
  const Section = ({ title, children }) => (
    <div style={{ marginBottom: 28 }}>
      <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:18, fontWeight:700, color:"#1a1a2e", marginBottom:10 }}>{title}</h3>
      <div style={{ fontSize:14, color:"#555", lineHeight:1.8 }}>{children}</div>
    </div>
  );

  return (
    <div className="page-top-pad" style={{ background:"white", minHeight:"100vh" }}>
      <div style={{ background:"linear-gradient(135deg,#1a1a2e,#2d1b69)", padding:"28px clamp(16px,4vw,40px)" }}>
        <h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:"clamp(22px,4vw,34px)", fontWeight:900, color:"white" }}>Privacy Policy</h1>
        <p style={{ fontSize:12, color:"rgba(255,255,255,0.7)", marginTop:6 }}>Last updated: {new Date().toLocaleDateString("en-IN",{year:"numeric",month:"long",day:"numeric"})}</p>
      </div>

      <div style={{ maxWidth:760, margin:"0 auto", padding:"clamp(24px,5vw,48px) clamp(16px,4vw,40px)" }}>
        <div style={{ background:"#FFFBEB", border:"1px solid #FDE68A", borderRadius:10, padding:"12px 16px", fontSize:12, color:"#92400E", marginBottom:28 }}>
          ⚠️ Ye ek starting template hai — apni actual data practices ke hisaab se review/adjust kar lena.
        </div>

        <Section title="1. Information We Collect">
          When you create an account, place an order, or contact us, we may collect: your name, phone number, email
          address, delivery address, and order history. We do not collect or store payment card/UPI details — these are
          handled directly and securely by Razorpay.
        </Section>

        <Section title="2. How We Use Your Information">
          We use your information to: process and deliver your orders, send order confirmations and updates (via email
          and WhatsApp), respond to your queries, and improve our products and services.
        </Section>

        <Section title="3. Information Sharing">
          We do not sell your personal information to third parties. We share necessary details (name, address, phone)
          with our logistics/courier partners solely to deliver your order, and with Razorpay solely to process payment.
        </Section>

        <Section title="4. Data Security">
          Your account is protected by Supabase Authentication with encrypted password storage. We take reasonable
          measures to protect your data, but no online system can be guaranteed 100% secure.
        </Section>

        <Section title="5. Cookies">
          Our website may use basic cookies/local storage to remember your cart and preferences. We do not use
          third-party advertising trackers at this time.
        </Section>

        <Section title="6. Your Rights">
          You may request to view, correct, or delete your personal data at any time by contacting us via WhatsApp or
          our <span onClick={()=>onNav("contact")} style={{color:"#EC4899",cursor:"pointer",fontWeight:700}}>Contact Us</span> page.
        </Section>

        <Section title="7. Children's Privacy">
          Our services are not directed at children under 18. We do not knowingly collect data from minors.
        </Section>

        <Section title="8. Changes to This Policy">
          We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated date.
        </Section>

        <Section title="9. Contact Us">
          For privacy-related questions, please reach out via our{" "}
          <span onClick={()=>onNav("contact")} style={{color:"#EC4899",cursor:"pointer",fontWeight:700}}>Contact Us</span> page.
        </Section>
      </div>
      <Footer onNav={onNav}/>
    </div>
  );
}
